import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Herosec() {
  const hourRef = useRef();
  const minRef = useRef();
  const secRef = useRef();
  const [endTime, setEndTime] = useState(null);

  // Initialize or get the timer from localStorage
  useEffect(() => {
    // Default timer values
    hourRef.current.innerText = "00 ";
    minRef.current.innerText = "00 ";
    secRef.current.innerText = " 00 ";

    const HOURS_48 = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
    const now = new Date().getTime();
    
    // Try to get the stored end time from localStorage
    const storedEndTime = localStorage.getItem('countdownEndTime');
    
    if (storedEndTime) {
      const remainingTime = parseInt(storedEndTime, 10) - now;
      
      // If the stored time has passed, start a new 48-hour countdown
      if (remainingTime <= 0) {
        const newEndTime = now + HOURS_48;
        localStorage.setItem('countdownEndTime', newEndTime.toString());
        setEndTime(newEndTime);
      } else {
        setEndTime(parseInt(storedEndTime, 10));
      }
    } else {
      // First time or localStorage was cleared, set a new 48-hour countdown
      const newEndTime = now + HOURS_48;
      localStorage.setItem('countdownEndTime', newEndTime.toString());
      setEndTime(newEndTime);
    }
  }, []);

  // Update the countdown every second
  useEffect(() => {
    if (!endTime) return;

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        // Countdown finished, restart it
        const newEndTime = now + (48 * 60 * 60 * 1000);
        localStorage.setItem('countdownEndTime', newEndTime.toString());
        setEndTime(newEndTime);
        return;
      }

      // Time calculations for hours, minutes, seconds
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update the refs
      if (hourRef.current) {
        hourRef.current.innerText = hours.toString().padStart(2, '0') + " ";
      }
      if (minRef.current) {
        minRef.current.innerText = minutes.toString().padStart(2, '0') + " ";
      }
      if (secRef.current) {
        secRef.current.innerText = seconds.toString().padStart(2, '0') + " ";
      }
    };

    // Initial call
    updateCountdown();

    // Update every second
    const interval = setInterval(updateCountdown, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [endTime]);
  return (
    <section id="hero" className="topsec sa-home-hero-contsiner">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div
              className="topseccont"
              style={{ paddingLeft: "0", paddingBottom: "1rem" }}
            >
              <span className="sa-hero-dealtime" >🎉 Limited Time Offer ends in</span> <br />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                  marginTop: "0.7rem",
                }}
                className="timer"
              >
                <span className="sa-home-hero-timer">
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  {/* <span>{hours}</span> */}
                  <span ref={hourRef}></span>
                </span>{" "}
                :
                <span className="sa-home-hero-timer">
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <span ref={minRef}></span>
                  {/* <span>{minutes}</span> */}
                </span>{" "}
                :
                <span className="sa-home-hero-timer">
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <span ref={secRef}></span>
                  {/* <span>{seconds}</span> */}
                  <br></br>
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "12rem",
                  marginTop: "0.2rem",
                }}
                className="time-desc"
              >
                <h6 style={{ marginRight: "2.8rem" }}>Hrs</h6>
                <h6>Mins</h6>
                <h6 style={{ marginLeft: "2.8rem" }}>Sec</h6>
              </div>
              <h1
                className="sa-home-hero-heading"
                style={{
                  fontSize: "2.3rem",
                  color: "#21bcc3",
                  marginBottom: "0",
                }}
              >
                🚀 MEGA HOSTING DEALS <br />
              </h1>
              <p className="sa-home-hero-headdisc">
                POWER YOUR WEBSITE WITH FREE HOSTING + MIGRATION + SSL
              </p>
              <div className="sa-percentage-off" style={{ 
                background: "#ffffff", 
                color: "transparent",
                backgroundImage: "linear-gradient(135deg, #21bcc3 0%, #17a2b8 50%, #3b8af2 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold"
              }}>40% OFF</div>
              <div className="sa-home-hero-para">
                ✨ SPECIAL OFFER - FREE DOMAIN FOR LIFE:
                <img src="../assets/img/home-hero-store.svg" alt="in" />
                <img src="../assets/img/home-hero.tech.svg" alt="tech" />
                <img src="../assets/img/home-hero-online.svg" alt="online" />
                <img src="../assets/img/domain_img/site.png" alt="site" />
              </div>
              <p className="sa-home-hero-para">
                � STARTING AT ₹12/MO WITH COUPON CODE:
                <span className="sa-text-blue" style={{ color: "#21bcc3", fontWeight: "bold" }}> MEGA40</span>
              </p>
            </div>
          </div>
          <div className="col-lg-5 d-lg-flex d-none justify-content-center">
            <img
              className="topsecimg bounce-img hero-img"
              src="../assets/img/clubhosty-hero-1.png"
              alt="home"
            />
          </div>
        </div>
        <div
          className="d-flex align-items-center sa-home-hero-bottomdiv"
          style={{ padding: "0 0 1rem 0" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "22rem",
            }}
          >
            <Link
              to="/sharedHosting"
              className="btn-started scrollto sa-home-hero-btn"
            >
              START NOW
            </Link>
            <Link
              to="/sharedHosting"
              className="btn-started scrollto sa-home-hero-btn"
            >
              PLANS & PRICING
            </Link>
          </div>
          <div className="hero-trust">
            <div className="sa-home-hero-ratesec">
              <h6 className="sa-rating-head">
                <Link
                  to="https://hostadvice.com/hosting-company/clubhosty-reviews/#write-review"
                  target="_blank"
                >
                  {" "}
                  <img
                    src="../assets/img/HostAdviceLogo.svg"
                    alt="Hostadvice"
                    style={{ width: "5.5rem", paddingBottom: "15px" }}
                  />{" "}
                </Link>
                {/* Reviews */}
              </h6>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="HA1"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="HA2"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="HA3"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="HA4"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="HA5"
                  ></img>
                </span>
              </div>
              <div className="sa-home-hero-ratinginfo">
                <span>Rating 4.7/5 </span>
                <span style={{ borderLeft: "1.5px solid black" }}>
                  &nbsp;40 reviews
                </span>
              </div>
            </div>
            <div className="sa-home-hero-ratesec">
              <h6 className="sa-rating-head">
                <Link
                  to="https://g.page/r/CVFdw5DSCAs1EAI/review"
                  target="_blank"
                >
                  <img
                    src="../assets/img/googleLogo.png"
                    alt="Google"
                    style={{ width: "4rem", paddingBottom: "7px" }}
                  />{" "}
                </Link>
                {/* Reviews */}
              </h6>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G1"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G2"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G3"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G4"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="TP5"
                  ></img>
                </span>
              </div>
              <div className="sa-home-hero-ratinginfo">
                <span>Rating 3.5/5 </span>
                <span style={{ borderLeft: "1.5px solid black" }}>
                  &nbsp;31 reviews
                </span>
              </div>
            </div>
            <div className="sa-home-hero-ratesec">
              <h6 className="sa-rating-head">
                <Link
                  to="https://www.g2.com/products/clubhosty/reviews"
                  target="_blank"
                >
                  <img
                    src="../assets/img/G2Logo.png"
                    alt="G2"
                    className="g2logo"
                    style={{ width: "1.8rem", paddingBottom: "5px" }}
                  />{" "}
                </Link>
                Reviews
              </h6>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G21"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G22"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G23"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G24"
                  ></img>
                </span>

                <span
                  className="sa-home-hero-rating"
                  style={{ position: "relative" }}
                >
                  <img
                    className="sa-polygon"
                    src="../assets/img/hero-sec-polygon.svg"
                    alt="polygon"
                    style={{ position: "absolute", width: "100%" }}
                  />
                  <img
                    className="sa-star"
                    src="../assets/img/ph_star-fill.svg"
                    alt="G25"
                  ></img>
                </span>
              </div>
              <div className="sa-home-hero-ratinginfo">
                <span>Rating 4.1/5 </span>
                {/* <span style={{ borderLeft: "1.5px solid black" }}>
                  &nbsp;833 reviews
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Herosec;
